import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../App';

export default function BackButton({ fallbackTo = '/' }) {
  const navigate = useNavigate();
  const { isNightMode } = useTheme();
  const [isHovering, setIsHovering] = useState(false);

  return (
    <button
      type="button"
      onClick={() => {
        if (typeof window !== 'undefined' && window.history && window.history.length > 1) {
          navigate(-1);
        } else {
          navigate(fallbackTo);
        }
      }}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: 0,
        border: 'none',
        background: 'transparent',
        color: isNightMode ? '#cbd5e1' : '#374151',
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: 13,
        opacity: isHovering ? 0.85 : 1,
        textDecoration: isHovering ? 'underline' : 'none',
        textUnderlineOffset: 3,
      }}
      aria-label="Go back"
    >
      <span aria-hidden style={{ fontSize: 14, lineHeight: 1 }}>
        ←
      </span>
      <span>Back</span>
    </button>
  );
}
